module.exports = __webpack_public_path__ + "media/images/icons/material/handshake-9669a41e6a9f0add3123ffea8724fe3f.svg";